import React from "react";
import DownVector from "../../images/Svg/DownVector.svg";
import upVector from "../../images/Svg/upVector.svg";
const parse = require("html-react-parser");
const FaqComponents = ({ data, toggle, isOpen }) => {
  const { question, answer } = data;
  return (
    <div
      className={`mb-6 sm:mx-auto w-[full] shadow border-x border-[#E1E1E1] p-[24px] rounded-[12px] hover:shadow-md`}
    >
      <div
        onClick={() => toggle(data?.id)}
        className="flex items-center justify-between cursor-pointer"
      >
        {" "}
        <h3
          className={`${
            data?.id === isOpen ? "text-blue" : "text-[#161616]"
          } text-[20px] font-bold`}
        >
          {question}
        </h3>{" "}
        <img
          className="w-[15px] h-[15px]"
          src={data?.id === isOpen ? upVector : DownVector}
          alt=""
        />{" "}
      </div>{" "}
      {data?.id === isOpen ? (
        <p className="text-[#161616] text-[16px] my-[16px]">
          {answer && parse(answer)}
        </p>
      ) : (
        <p></p>
      )}
    </div>
  );
};
export default FaqComponents;
